import snakecaseKeys from 'snakecase-keys';

import { restClient } from '../../client';
import { Address } from '../../resources';

/**
 * Represents the type of insurance holder.
 * Corresponds with the "is_primary" field in the create partner insurance API (/api/v1/insurance).
 */
type HolderType = 'primary' | 'secondary';

export type NonPartnerInsuranceInput = {
  studentId: string;
  companyId: string;
  subscriberId: string;
  groupNumber: string;
  holderType: HolderType;
  cardPhotos: {
    frontAssetId: string;
    backAssetId: string;
  };
  holderInfo: {
    firstName: string;
    lastName: string;
    dob: string;
    address: {
      line_1: string;
      line_2: string;
      city: string;
      stateId: string;
      zip: string;
    };
  };
};

export type UpdateNonPartnerInsuranceInput = Omit<NonPartnerInsuranceInput, 'studentId'>;

export type NonPartnerInsurance = Omit<NonPartnerInsuranceInput, 'holderInfo'> & {
  id: string;
  createdAt: string;
  updatedAt: string;
  archivedAt?: string;
  holderInfo: {
    firstName: string;
    lastName: string;
    dob: string;
    address: Address;
  };
};

export const createNonPartnerInsurance = (data: NonPartnerInsuranceInput) =>
  restClient.request<{ data: NonPartnerInsurance }>('/api/v1/higher_ed/non_partner_insurance', {
    method: 'POST',
    data: snakecaseKeys(data),
  });

export type GetNonPartnerInsuranceByStudentIdResponse = {
  data: NonPartnerInsurance[];
};

export const getNonPartnerInsuranceByStudentId = (studentId: string, includeArchived = true) =>
  restClient.request<GetNonPartnerInsuranceByStudentIdResponse>(
    `/api/v1/higher_ed/non_partner_insurance/by_student_id/${studentId}`,
    {
      method: 'GET',
      params: {
        include_archived: includeArchived,
      }
    });

export const updateNonPartnerInsurance = (insuranceId: NonPartnerInsurance['id'], data: UpdateNonPartnerInsuranceInput) =>
  restClient.request<{ data: NonPartnerInsurance }>(
    `/api/v1/higher_ed/non_partner_insurance/${insuranceId}`,
    {
      method: 'PUT',
      data: snakecaseKeys(data),
    });

export const deleteNonPartnerInsurance = (insuranceId: NonPartnerInsurance['id']) =>
  restClient.request(`/api/v1/higher_ed/non_partner_insurance/${insuranceId}`, {
    method: 'DELETE',
  });
